const initScrollToTop = () => {
  const buttonScrollToTop = document.querySelector(".scroll-to-top__button");
  const onClickButtonScrollToTop = (evt) => {
    evt.preventDefault();
  
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!buttonScrollToTop) {
    return;
  }
  
    
  if (window.scrollY > 200) {
    buttonScrollToTop.classList.add('is-visible');
  }

  window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
      buttonScrollToTop.classList.add('is-visible');
    } else {
      buttonScrollToTop.classList.remove('is-visible');
    }
  });
  
  buttonScrollToTop.addEventListener('click', onClickButtonScrollToTop);
};

export default initScrollToTop;
 